import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import '../../../assets/js/admin.js';
import { Router, RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ConfigApi } from '../../shared/config-api.model.js';
declare var $: any;


@Component({
  selector: 'app-layout-inicial',
  templateUrl: './layout-inicial.component.html',
  styleUrls: ['./layout-inicial.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LayoutInicialComponent {

  baseHref: any;
  //private configUrl = '../assets/config.json';  // Para teste localhost
  private configUrl = 'assets/config.json'

  constructor(private router: Router,
    private httpClient: HttpClient) {
    // this.loadConfig();
  }


  logout() {
    localStorage.removeItem('configuracoes');
    this.router.navigate(['login']);
  }

  // loadConfig() {
  //   this.httpClient
  //     .get<ConfigApi>(this.configUrl)
  //     .pipe()
  //     .subscribe(res => {
  //       this.baseHref = res.baseHref
  //     });
  // }

  getUrlImagemLogo() {
    return `../${this.baseHref}/assets/images/LogoPortal.png`;
  }
}



// WEBPACK FOOTER //
// D:/Agents/amapa/_work/8/s/ANGULAR/src/app/layout/layout-inicial/layout-inicial.component.ts